import { CorrectInvalidMarketInfoParam } from '../../MarketInfo/api/MarketInfoApi';
import { RootState } from '../../../app/store';
import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit"
import { InvalidMarketInfoModel } from '../models/InvalidMarketInfoModel';
import { OrderDirection } from '../../Datatable/OrderDirection';

interface invalidMarketInfoState {
    invalidMarketInfoData: InvalidMarketInfoModel[],
    invalidMarketInfoDisplay: InvalidMarketInfoModel[],
    selectedItem: InvalidMarketInfoModel | null,
    searchText: string,
    orderBy: string,
    orderDirection: OrderDirection,
    refreshInvalidMarketInfoTable: number,
    openEditInvalidMarketInfoModal: boolean,
    editItemParam: CorrectInvalidMarketInfoParam,
}

const initialState: invalidMarketInfoState = {
    invalidMarketInfoData: [],
    invalidMarketInfoDisplay: [],
    selectedItem: null,
    searchText: "",
    orderBy: "updatedDate",
    orderDirection: OrderDirection.Desc,
    refreshInvalidMarketInfoTable: 0,
    openEditInvalidMarketInfoModal: false,
    editItemParam: {
        id: 0,
        chartererId: "",
        cargoTypeId: null,
        ownerId: "",
        loadPort: null,
        disport: null
    }
}

export const InvalidMarketInfoSlice = createSlice({
    name: "InvalidMarketInfoInput",
    initialState,
    reducers: {
        setInvalidMarketInfoData: (state, action: PayloadAction<InvalidMarketInfoModel[]>) => {
            state.invalidMarketInfoData = action.payload;
        },
        setInvalidMarketInfoDisplay: (state, action: PayloadAction<InvalidMarketInfoModel[]>) => {
            state.invalidMarketInfoDisplay = action.payload;
        },
        setSelectedItem: (state, action: PayloadAction<InvalidMarketInfoModel>) => {
            state.selectedItem = action.payload;
        },
        setInvalidMarketInfoSearchText: (state, action: PayloadAction<string>) => {
            state.searchText = action.payload;
        },
        setInvalidMarketInfoOrderBy: (state, action: PayloadAction<string>) => {
            state.orderBy = action.payload;
        },
        setInvalidMarketInfoOrderDirection: (state, action: PayloadAction<OrderDirection>) => {
            state.orderDirection = action.payload;
        },
        setRefreshInvalidMarketInfoTable: (state, action: PayloadAction<number>) => {
            state.refreshInvalidMarketInfoTable = action.payload;
        },
        setOpenEditInvalidMarketInfoModal: (state, action: PayloadAction<boolean>) => {
            state.openEditInvalidMarketInfoModal = action.payload;
        },
        setCorrectInvalidMarketInfoParam: (state, action: PayloadAction<CorrectInvalidMarketInfoParam>) => {
            state.editItemParam = action.payload;
        },
    }
});

export const invalidMarketInfoSelector = createSelector(
    (state: RootState) => state.invalidMarketInfo,
    (data) => data
);

export const {
    setInvalidMarketInfoData,
    setInvalidMarketInfoDisplay,
    setSelectedItem,
    setInvalidMarketInfoSearchText,
    setInvalidMarketInfoOrderBy,
    setInvalidMarketInfoOrderDirection,
    setRefreshInvalidMarketInfoTable,
    setOpenEditInvalidMarketInfoModal,
    setCorrectInvalidMarketInfoParam
} = InvalidMarketInfoSlice.actions;

export default InvalidMarketInfoSlice.reducer;